/**
 * Enum for Log Type
 * @readonly
 * @enum {number}
 */
export var LogType;
(function (LogType) {
    LogType[LogType["Default"] = 0] = "Default";
    LogType[LogType["BeginActivity"] = 1001] = "BeginActivity";
    LogType[LogType["EndActivity"] = 1002] = "EndActivity";
    LogType[LogType["Transfer"] = 1003] = "Transfer";
    LogType[LogType["BeginSession"] = 1004] = "BeginSession";
    LogType[LogType["EndSession"] = 1005] = "EndSession";
    LogType[LogType["BeginNetworkActivity"] = 1006] = "BeginNetworkActivity";
    LogType[LogType["EndNetworkActivity"] = 1007] = "EndNetworkActivity";
    LogType[LogType["Instrumentation"] = 2001] = "Instrumentation";
})(LogType || (LogType = {}));
//# sourceMappingURL=LogType.js.map